module.exports = __webpack_public_path__ + "static/media/angle-down-solid.60e3dae4.svg";